export const breadcrumbMap = {
	comunicacao: 'Comunicação',
	administracao: 'Administração',
	usuarios: 'Usuários',
};
